module.exports = __webpack_public_path__ + "static/media/tab-gear-icon-active.307633b1.png";